import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../constants/colors";

export default makeStyles((theme) => ({
  appBarContainer: {
    padding: "15px 30px",
  },
  appBar: {
    backgroundColor: `${COLORS.accent}`,
    borderRadius: "15px",
  },
  websiteLogoContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  webisteLogo: {
    height: 50,
    "@media(max-width: 600px)": {
      height: 35,
    },
  },
}));
